module.exports = __webpack_public_path__ + "distribution/img/btn2.a35567cc.png";